import type { NDateLocale } from './enUS'
import { he } from 'date-fns/locale'

const dateHeIL: NDateLocale = {
  name: 'he-IL',
  locale: he
}

export default dateHeIL
